export default __webpack_public_path__ + "static/media/partner-1.a53c546b.png";